import { useState, CSSProperties, useEffect, Fragment } from "react";
import { StyleSheet } from "react-native";

interface CustomProgressBarProps {
    id?: string,
    width: number,
    height: number,
    innerText?: string,
    innerTextStyle?: CSSProperties,
    colors: string[],
    percent: number;
}

function CustomProgressBar(props:CustomProgressBarProps) {
    const [percent, setPercent] = useState(0);
    const [backgroundContainerStyle, setBackgroundContainerStyle] = useState(className.backgroundContainer);
    const [graphContainerStyle, setGraphContainerStyle] = useState(className.graphContainer);
    
    useEffect(() => {
        setBackgroundContainerStyle({...className.backgroundContainer, width: props.width + "px", height: props.height + "px", backgroundColor: props.colors[1]});
        setGraphContainerStyle({...className.graphContainer, width: "0px", height: props.height + "px", backgroundColor: props.colors[0]});
    }, []);

    useEffect(() => {
        setGraphContainerStyle({...graphContainerStyle, width: (props.width / (Number(100 / props.percent))) + "px", height: props.height + "px", backgroundColor: props.colors[0]});
    }, [props.percent]);

    return (
        <Fragment>
            <div style={backgroundContainerStyle}>
                <div style={graphContainerStyle}>
                    {
                        props.innerText && props.innerTextStyle ? <div style={props.innerTextStyle}>{props.innerText}</div>:null
                    }
                </div>
            </div>
        </Fragment>
    );
}


const style = StyleSheet.create({

});

const className = {
    backgroundContainer: {
        width: "100px",
        height: "10px",
        borderRadius: "5px",
        backgroundColor: "#fff",
        overflow: "hidden"
    },
    graphContainer: {
        width: "0px",
        height: "10px",
        borderRadius: "5px",
        backgroundColor: "#000",
        opacity: "0.4",
        transitionProperty: "width",
        transitionDuration: "0.5s",
    }
};

export default CustomProgressBar;